<form [formGroup]="group">
    <div class="a-w1-row">
        <p-floatlabel variant="on" class="a-w6">
            <p-multiSelect [options]="listaAnios" formControlName="anio" class="w-full" size="small"></p-multiSelect>
            <label for="anio">Años</label>
        </p-floatlabel>
        <p-floatlabel variant="on" class="a-w6">
            <p-select id="regimen" [options]="ListaRegimen" appendTo="body" formControlName="regimen"
                styleClass="w-full" [filter]="false" [showClear]="true" optionLabel="nombre" size="small" />
            <label for="regimen">Regimen</label>
        </p-floatlabel>
        <p-floatlabel variant="on" class="a-w6">
            <p-select id="lineanegocio" [options]="ListaLineaNegocio" appendTo="body" formControlName="lineanegocio"
                styleClass="w-full" [filter]="false" [showClear]="true" optionLabel="nombre" size="small" />
            <label for="lineanegocio">Linea Negocio</label>
        </p-floatlabel>
        <div>
            <p-button icon="pi pi-search" [outlined]="true" severity="info" (onClick)="search()"></p-button>
        </div>
    </div>
</form>
<div class="a-w1-column">
    <app-datatable [dataTable]="indicadores" [metadataTable]="metadatatable2" [filter]="false" [preload]="preload">
    </app-datatable>
    <app-datatable [dataTable]="dataTable" [metadataTable]="metadatatable" [filter]="true" [preload]="preload"
        [rows]="[20,50,100,200,300,500]" *ngIf="dataTable.length !=0" [exportData]="true"></app-datatable>
</div>
<div class="a-footer"></div>